import React from 'react';
import { getFileTypeCategory } from '../../../utils/fileUtils';

// Import SVG icons
import docIcon from '../../../assets/file-icons/doc.svg';
import xlsIcon from '../../../assets/file-icons/xls.svg';
import pptIcon from '../../../assets/file-icons/ppt.svg';
import pdfIcon from '../../../assets/file-icons/pdf.svg';
import imageIcon from '../../../assets/file-icons/image.svg';
import otherIcon from '../../../assets/file-icons/other.svg';

// Import filter icons (16px versions)
import filterDocIcon from '../../../assets/file-icons/filter-doc.svg';
import filterXlsIcon from '../../../assets/file-icons/filter-xls.svg';
import filterPptIcon from '../../../assets/file-icons/filter-ppt.svg';
import filterPdfIcon from '../../../assets/file-icons/filter-pdf.svg';
import filterImageIcon from '../../../assets/file-icons/filter-image.svg';

interface FileTypeIconProps {
  extension: string;
  size?: number;
}

export const FileTypeIcon: React.FC<FileTypeIconProps> = ({ extension, size = 32 }) => {
  const category = getFileTypeCategory(extension);
  
  // Use filter icons for small sizes (16px), regular icons for larger sizes
  const useFilterIcon = size <= 16;
  
  // Map category to icon
  const getIconSrc = (): string => {
    if (useFilterIcon) {
      // Use 16px filter icons
      switch (category) {
        case 'word':
          return filterDocIcon;
        case 'excel':
          return filterXlsIcon;
        case 'powerpoint':
          return filterPptIcon;
        case 'pdf':
          return filterPdfIcon;
        case 'image':
          return filterImageIcon;
        default:
          return otherIcon; // Use other icon as fallback for small sizes
      }
    } else {
      // Use 32px regular icons
      switch (category) {
        case 'word':
          return docIcon;
        case 'excel':
          return xlsIcon;
        case 'powerpoint':
          return pptIcon;
        case 'pdf':
          return pdfIcon;
        case 'image':
          return imageIcon;
        default:
          return otherIcon;
      }
    }
  };
  
  return (
    <img 
      src={getIconSrc()} 
      alt={`${category} file icon`}
      width={size}
      height={size}
      style={{ display: 'block' }}
    />
  );
};
